import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TokenWizardPage } from '@/features/access/tokens/token-wizard';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Segment statique : gagne sur les détails (`agents/$identityId`, `api/$applicationId`). */
export const Route = createFileRoute('/$tenant/tokens/new')({ component: NewTokenRoute });

function NewTokenRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="tokens"
      crumbs={[{ label: t('access.tokens.title') }, { label: t('access.tokens.wizard.title') }]}
    >
      <TokenWizardPage tenantId={tenant} />
    </ConsoleShell>
  );
}
